import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import servicioUsuario from '../servicios/ServicioUsuario';

export class Manual extends React.Component {
    constructor() {
        super();
        this.state = {
            mostrarModalGuia: false,
            mostrarModalInformacion: false,
            documento: null
        }
    }

    mostrarModalGuia() {
        this.generaDocumento('guia');
        this.setState({ mostrarModalGuia: true });
    }

    mostrarModalInformacion() {
        this.generaDocumento('informacion');
        this.setState({ mostrarModalInformacion: true });
    }

    generaDocumento(dato) {
        let documento = { ...this.state };
        
        servicioUsuario.obtenerGuia('/documentos_logeo/descargar_documentos.json?documento='+dato).then((response) => {

            let headers = response.headers;
            let contentType = headers['content-type'];

            if (contentType.includes('application/json')){
                this.cerrarModal();
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: headers['mensaje'] });
            }
               

            let encabezadoContent = headers['content-disposition'];
            let result = encabezadoContent.split(';')[1].trim().split('=')[1];
            let fileName = result.replace(/"/g, '');
            let a = document.createElement("a");

            let tipo = "application/pdf";
            document.body.appendChild(a);
            let file = new Blob([response.data], {
                type: tipo
            });

            let fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            documento=a.href;
            this.setState({ documento })

        })
            .catch((error) => { })
    }

    cerrarModal() {
        this.setState({ mostrarModalInformacion: false, mostrarModalGuia: false });
    }

    componentWillUnmount() { }

    render() {
        let { mostrarModalGuia, mostrarModalInformacion, documento } = this.state;
        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <button onClick={this.mostrarModalInformacion.bind(this)} style={{ border: "none", backgroundColor: "transparent", outline: "none", }} > <strong style={{ color: '#4CAF50' }}>Más información</strong></button>
                <button onClick={this.mostrarModalGuia.bind(this)} style={{ border: "none", backgroundColor: "transparent", outline: "none", }} > <strong style={{ color: '#4CAF50' }}>Guía Rápida</strong></button>
                <div>
                    <Dialog closeOnEscape={true} appendTo={document.body} header='Guía Rapida' visible={mostrarModalGuia} modal={true} onHide={this.cerrarModal.bind(this)} >
                        <div>
                            <iframe width="560" height="315" src={documento} title="title" frameBorder="0" allowFullScreen>
                            </iframe>
                        </div>
                    </Dialog>
                    <Dialog closeOnEscape={true} appendTo={document.body} header='Más información' visible={mostrarModalInformacion} modal={true} onHide={this.cerrarModal.bind(this)} >
                        <div>
                            <iframe width="560" height="315" src={documento} title="title" frameBorder="0" allowFullScreen>
                            </iframe>
                        </div>
                    </Dialog>
                </div>
            </div>
        );
    }

}